import { render, staticRenderFns } from "./RotateRightIcon.vue?vue&type=template&id=8e0197c0&"
import script from "./RotateRightIcon.vue?vue&type=script&lang=js&"
export * from "./RotateRightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports